import {useState} from "react";
import {noteToParagraph} from "../../helpers";
import {Button} from "antd";

export default function ReadMore({text}) {
    const [expanded, setExpanded] = useState(false);

    if (!text) {
        return null;
    }

    if (text.split("\n").length <= 2) {
        return (
            <div>
                {noteToParagraph(text)}
            </div>
        );
    }

    const preview = text.split("\n").slice(0, 2).join("\n");
    return (

        <div>
            {expanded ? noteToParagraph(text) : noteToParagraph(preview)}
            <Button type={"link"} style={{margin: 0, padding: 0}}
                    onClick={() => setExpanded(!expanded)}
            >
                {expanded ? "minder" : "meer lezen"}
            </Button>
        </div>

    );
}
